<template>
    <div class="container">
        <div class="about-banner">
            <img src="../../assets/images/banner-6.png" />
        </div>
        <div class="navigation-bar">
            <div class="navigation-bar-txt">
                <span class="title"><router-link to="/">{{ t('menu.home') }}</router-link></span>
                <span>{{ t('servicechildmenu.service4') }}</span>
            </div>
        </div>
        <div class="traninglist">
            <h2 class="title">{{ t('hosting.moduleA.title') }}</h2>
            <p>{{ t('hosting.moduleA.desc') }}</p>
            <h2 class="title">{{ t('hosting.moduleA.title1') }}</h2>
            <p>{{ t('hosting.moduleA.desc1') }}</p>
            
        </div>
    </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
<style lang="scss" scoped>
.about-box {
    margin: 0 auto;
    width: 1280px;
}

.about-banner {
    width: 100%;
    position: relative;

    img {
        display: block;
        width: 100%;
    }

    p {
        width: 800px;
        position: absolute;
        text-align: center;
        left: 50%;
        margin-left: -400px;
        color: #fff;
    }

    .title {
        top: 220px;
        font-size: 50px;
    }

    .learn-btn {
        cursor: pointer;
        top: 320px;
        width: 170px;
        height: 46px;
        font-size: 20px;
        line-height: 40px;
        position: absolute;
        text-align: center;
        left: 50%;
        border: 1px solid #fff;
        margin-left: -85px;
        color: #fff;
        border-radius: vars.$radius-4;

        &:hover {
            background-color: vars.$base-color;
            color: #fff;
            border: 1px solid vars.$base-color;
        }

        .topright-btn {
            margin-top: 10px;
        }
    }
}

.traninglist {
    width: 1280px;
    margin: 0 auto;
    padding-bottom: 60px;

    .title {
        padding: 40px 0px 40px 0px;
        font-size: 24px;
        text-align: left;
    }
    p{
        font-size: 14px;  
    }
    
}
</style>